module.exports = __webpack_public_path__ + "img/en_grey.3cf3294c.svg";